import { prefersReducedMotion } from './util';

let layer: HTMLElement | null = null;

function getLayer(): HTMLElement {
  if (!layer || !layer.isConnected) {
    layer = document.createElement('div');
    layer.className = 'confetti-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);
  }
  return layer;
}

function pieceColor(): string {
  // Mostly ink-toned squares, occasionally the accent — Swiss confetti.
  const roll = Math.random();
  if (roll < 0.3) return 'var(--accent)';
  if (roll < 0.65) return 'var(--text-tertiary)';
  return 'var(--text-primary)';
}

function spawn(x: number, y: number, keyframes: Keyframe[], duration: number): void {
  const span = document.createElement('span');
  span.className = 'confetti-piece';
  span.style.left = `${x}px`;
  span.style.top = `${y}px`;
  span.style.background = pieceColor();
  getLayer().appendChild(span);
  const anim = span.animate(keyframes, { duration, easing: 'cubic-bezier(0.2, 0.6, 0.4, 1)' });
  anim.onfinish = () => span.remove();
}

/** Burst a few small squares outward from a point (row-icon click). Subtle. */
export function burstConfetti(x: number, y: number, count = 6): void {
  if (prefersReducedMotion()) return;
  for (let i = 0; i < count; i++) {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.6;
    const dist = 22 + Math.random() * 28;
    const dx = Math.cos(angle) * dist;
    const dy = Math.sin(angle) * dist - 16;
    spawn(
      x,
      y,
      [
        { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
        {
          transform: `translate(${dx}px, ${dy + 40}px) rotate(${Math.random() * 240 - 120}deg)`,
          opacity: 0,
        },
      ],
      380 + Math.random() * 140,
    );
  }
}

/** Rain confetti squares down the viewport (the `party` easter egg). */
export function rainConfetti(total = 80): void {
  if (prefersReducedMotion()) return;
  const w = window.innerWidth;
  const h = window.innerHeight;
  for (let i = 0; i < total; i++) {
    const x = Math.random() * w;
    const delay = Math.random() * 900;
    setTimeout(() => {
      spawn(
        x,
        -12,
        [
          { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
          {
            transform: `translate(${(Math.random() - 0.5) * 120}px, ${h + 40}px) rotate(${Math.random() * 540 - 270}deg)`,
            opacity: 0.9,
          },
        ],
        1500 + Math.random() * 1500,
      );
    }, delay);
  }
}
